import { NgModule } from '@angular/core';
import { OverlayMaskComponent } from './overlay-mask.component';

@NgModule({
  declarations: [OverlayMaskComponent],
  exports: [OverlayMaskComponent],
})
export class OverlayMaskModule {}
